import { PrintDoc } from '../print/PrintDoc';
import { fmt } from '../shared/badges';

// Ordre de transfert remis à l'agent d'atelier : quantité théorique, tonnage réel à relever.
export const OrdreTransfertDoc = ({ ordre, onClose }) => (
  <PrintDoc
    type="Ordre de transfert inter-cuves"
    format="a5"
    numero={ordre.numero}
    date={ordre.date}
    tiers="Atelier — service pompage"
    lignes={[
      ['Cuve source', ordre.sourceNom],
      ['Cuve de destination', ordre.cibleNom],
      ['Quantité théorique à transférer', `${fmt(ordre.qteTheorique, 1)} kg`],
      ['Ordre émis par', ordre.creePar ?? '—'],
      ['Tonnage réel transféré', '............................ kg'],
      ['Heure de début / fin de pompage', '......... : .........  →  ......... : .........'],
    ]}
    totaux={[]}
    mentions="Les stocks ne sont mouvementés qu'après validation du tonnage réel par l'administration. Relevez le tonnage exact effectivement pompé et retournez ce bon signé."
    signatures={['Signature de l’agent d’atelier', 'Visa administration']}
    onClose={onClose}
  />
);
